<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <!-- <div class="rj-page-card__title">
        退货合同
      </div> -->
      <div class="rj-page-card__content">
        <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
          <div class="rj-row">
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.projectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.createdTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退换货申请单号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.orderNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原客户合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.oldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.contractType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  币种：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.currencyName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.orderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                {{ info.orderUnitTel }}
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.finalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.customerContractType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.regionName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  二级渠道名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.secondChannelName || '无' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  二级渠道类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.secondChannelType || '无' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.assistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前姓名：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.preSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  外销姓名：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.salesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.salesPersonDeptName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.orderType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量计点：
                </div>
                <div class="rj-baseinfo__item">
                  {{ $store.getters['enumeration/getmeteringPoint'](info.meteringPoint) }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  贸易方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.tradeTerm }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运输方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.modeOfShipping }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  销往区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.salesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电源线规格(2pin)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.powerCordSpecification }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电源线规格(3pin)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.threePlugPowerCord }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  发货方式：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- <el-radio-group v-model="info.shipType" disabled>
                    <el-radio v-for="(type,index) in shipType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group> -->
                  {{ info.shipType===1?'齐套发货':'分批发货' ||'--' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  结算方式：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- <el-radio-group v-model="info.salesType" disabled> -->
                  <!-- <el-radio v-for="(type,index) in internationalSalesType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio> -->
                  {{ info.salesSettlementModes || '--' }}
                  <!-- </el-radio-group> -->
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  账期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.accountPeriod || '--' }}
                </div>
              </div>
            </div>

            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  净销售额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.netSales }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  即期/远期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.atAfterSight=='1'? '即期':'远期' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  远期时间：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.sightDate }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目代码（CRM编号）：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.opportunityCode }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  借条单号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.borrowingOrderNumber }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  CRM客户编码：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.crmAccountCode }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  使用返利金额：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- 退货合同 -->
                  <template v-if="isReturn">
                    {{ info.rebateAmount||0 }}
                  </template>
                  <!-- 换货合同 -->
                  <template v-if="!isReturn">
                    {{ info.userRebateAmount||0 }}
                  </template>
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  细分市场：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.marketSegmentName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  应用场合：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.applicationScenariosName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  云桌面授权邮箱：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.authorizationEmail ||'--' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  目的地：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.destination }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  齐套通知打款邮箱：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.setNoticeMail||'--' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  税率：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- 退货产品 -->
                  <template v-if="isReturn">
                    {{ info.formTaxRate ? info.formTaxRate + '%' : '--' }}
                  </template>
                  <!-- 换货产品 -->
                  <template v-if="!isReturn">
                    {{ info.taxRate ? info.taxRate + '%' : '--' }}
                  </template>
                </div>
              </div>
            </div>
            <!-- 采购类型-国际服务独立销售 -->
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  采购类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.purchaseType }}
                </div>
              </div>
            </div>
            <!-- 业务类型-国际服务独立销售 -->
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  业务类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.projectType }}
                </div>
              </div>
            </div>
            <!-- 是否返现金点-国际服务独立销售 -->
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否返现金点：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.cashbackPoints? '是' : '否' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  现金点比例：
                </div>
                <!--现金点比例-国际服务独立销售-->
                <div class="rj-baseinfo__item">
                  {{ info.cashPointRatio ? info.cashPointRatio : '--' }}
                </div>
                <!-- <div v-else class="rj-baseinfo__item">
                  {{ info.rebate ? `${info.rebate * 100}%` : '0%' }}
                </div> -->
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退换货原因：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- D8：落库值（如“产品发运错误”）经 displayReasonType 映射后再展示 -->
                  {{ displayReasonType(info.reasonType) }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原退货单总返利金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.originallyRebateAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退货合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.newContractNum }}
                </div>
              </div>
            </div>
            <div v-if="!isReturn" class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  仓库：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.warehouseName || '--' }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  补充条款：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplementalTerm }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  服务条款：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.serviceTerm }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收货回执及到货验收要求：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.specialRemarks }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  备注说明：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.remarks }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { displayReasonType } from '@/constant';

export default {
  data () {
    return {
      // info: {},
      loading: false,
      form: {},
      rules: {}
    };
  },
  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    },
    isReturn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // D8：退换货原因展示名映射（落库值保持不变，仅展示层生效）
    displayReasonType
  },
  mounted () {
  }
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
